import { CountryCode } from "./types";
import { supportedCountries } from "./countries";

// Helper function to get initial country (defaults to US)
export const getDefaultCountry = (): CountryCode => {
  return (
    supportedCountries.find(
      ({ dial_code, code }) => dial_code === "+1" && code === "US"
    ) ||
    supportedCountries.find(({ dial_code }) => dial_code === "+1") ||
    supportedCountries[0]
  );
};

export const getFlagUrl = (countryCode: string) => {
  return `/flags/3x2/${countryCode.toUpperCase()}.svg`;
};
